import { Box, Container, Paper, useMediaQuery, useTheme } from "@mui/material";
import { Skeleton } from '@mui/material';

export const CommentSectionSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Paper
      style={{
        marginTop: 11,
        borderTop: "#383838 solid 0.2px",
        borderBottom: "#383838 solid 1.5px",
      }}
    >
      <Container maxWidth="md">
        <Box my={2}>
          <Skeleton variant="rectangular" height={25} style={{ borderRadius: 5, width: "100%", margin: "10px 0px" }} />
          <Skeleton variant="rectangular" width={73} height={18} style={{ borderRadius: 5 }} />

          <Box display={"flex"} flexDirection="row" mt={2} borderRadius="5px">
            {/* avatar */}
            <Skeleton variant="circular" width={32} height={32} />

            {/* username & comment age */}
            <Box ml={1} width={"100%"}>
              <Box display={"flex"} className={"spacing"}>
                <Skeleton variant="text" width={50} />
                <Skeleton variant="text" width={50} />
              </Box>

              {/* comment text */}
              <Box mb={0.5}>
                <Skeleton variant="text" style={{ width: "100%", maxWidth: isMobile ? 300 : 500 }} />
                <Skeleton variant="text" style={{ width: "100%", maxWidth: isMobile ? 200 : 400 }} />
              </Box>

              <Box display={"flex"} className={"spacing"}>
                <Skeleton variant="rectangular" width={50} height={16} style={{ borderRadius: 5 }} />
                <Skeleton variant="circular" width={16} height={16} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Paper>
  );
};

export default CommentSectionSkeleton;
